/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Team_Studio_TwoInputs */

const en_platform_team_studio_two = /** @type {(inputs: Platform_Team_Studio_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone keeps their own hours and clients`)
};

const pl_platform_team_studio_two = /** @type {(inputs: Platform_Team_Studio_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każdy ma własne godziny i podopiecznych`)
};

/**
* | output |
* | --- |
* | "Everyone keeps their own hours and clients" |
*
* @param {Platform_Team_Studio_TwoInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_team_studio_two = /** @type {((inputs?: Platform_Team_Studio_TwoInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Team_Studio_TwoInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_team_studio_two(inputs)
	return en_platform_team_studio_two(inputs)
});